export default __webpack_public_path__ + "static/media/pincho-hombre-castano.bc010187.png";